import type { FormOptions } from '@customTypes/types';

export const helpWithOptions: FormOptions = {
  greenlakeSpecific: 'GreenLake Specific',
  arubaTechnicalTeam: 'Aruba Technical Team',
};

